import { RSAA } from 'redux-api-middleware'
import { getApiPath } from 'sidecar-utility-library'

import { types, initialState } from './types'

export const saveClinicalNotesForm = (expenseUuid, buildABillFormData) => {
  // Build form fields array from build-a-bill data
  // Exclude provider name, provider specialty, and visit reason for clinical notes
  const formFields = [
    {
      field: 'PLACE_OF_SERVICE',
      value: buildABillFormData.careType,
    },
    {
      field: 'IS_DOWN_PAYMENT',
      value: buildABillFormData.isthisADownPayment === 'true' ? 'yes' : 'no',
    },
    {
      field: 'NEW_OR_EXISTING_PATIENT',
      value: buildABillFormData.providerHistory,
    },
    {
      field: 'LENGTH_OF_VISIT',
      value: buildABillFormData.visitDuration,
    },
    {
      field: 'RECEIVED_BLOODWORK_OR_XRAYS',
      value: buildABillFormData.receivedBloodworkOrXrays,
    },
    {
      field: 'VISIT_DESCRIPTION',
      value: buildABillFormData.treatmentDescription,
    },
  ]

  // Add bundle info if a bundle was selected or user chose "No"
  if (
    buildABillFormData.bundleInfo !== null &&
    buildABillFormData.bundleInfo !== undefined
  ) {
    formFields.push({
      field: 'BUNDLE_INFO',
      value: JSON.stringify(buildABillFormData.bundleInfo), // Always JSON stringify (empty object {} for "No", full object for bundle)
    })
  }

  return {
    [RSAA]: {
      endpoint: getApiPath('exp', `expenses/${expenseUuid}/expense-form`),
      method: 'PUT',
      body: JSON.stringify({
        formType: 'CLINICAL_NOTE_INFO',
        formFields,
      }),
      types: [
        types.SAVE_CLINICAL_NOTES_FORM_REQUEST,
        {
          type: types.SAVE_CLINICAL_NOTES_FORM_SUCCESS,
          meta: { expenseUuid },
        },
        types.SAVE_CLINICAL_NOTES_FORM_ERROR,
      ],
    },
  }
}

export const fetchClinicalNotesForm = expenseUuid => ({
  [RSAA]: {
    endpoint: getApiPath(
      'exp',
      `expenses/${expenseUuid}/expense-form?formType=CLINICAL_NOTE_INFO`,
    ),
    method: 'GET',
    types: [
      types.FETCH_CLINICAL_NOTES_FORM_REQUEST,
      types.FETCH_CLINICAL_NOTES_FORM_SUCCESS,
      types.FETCH_CLINICAL_NOTES_FORM_ERROR,
    ],
  },
})

export const clearClinicalNotesError = () => ({
  type: types.CLEAR_CLINICAL_NOTES_ERROR,
})

export const clearClinicalNotesData = () => ({
  type: types.CLEAR_CLINICAL_NOTES_DATA,
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.SAVE_CLINICAL_NOTES_FORM_REQUEST:
    case types.FETCH_CLINICAL_NOTES_FORM_REQUEST: {
      return {
        ...state,
        clinicalNotes: {
          ...state.clinicalNotes,
          busy: true,
          error: null,
        },
      }
    }

    case types.SAVE_CLINICAL_NOTES_FORM_SUCCESS:
    case types.FETCH_CLINICAL_NOTES_FORM_SUCCESS: {
      return {
        ...state,
        clinicalNotes: {
          ...state.clinicalNotes,
          busy: false,
          entity: payload,
          error: null,
        },
      }
    }

    case types.SAVE_CLINICAL_NOTES_FORM_ERROR:
    case types.FETCH_CLINICAL_NOTES_FORM_ERROR: {
      return {
        ...state,
        clinicalNotes: {
          ...state.clinicalNotes,
          busy: false,
          error: payload.message || 'An error occurred',
        },
      }
    }

    case types.CLEAR_CLINICAL_NOTES_ERROR: {
      return {
        ...state,
        clinicalNotes: {
          ...state.clinicalNotes,
          error: null,
        },
      }
    }

    case types.CLEAR_CLINICAL_NOTES_DATA: {
      return {
        ...state,
        clinicalNotes: {
          busy: false,
          entity: {},
          error: null,
        },
      }
    }

    default:
      return state
  }
}
